/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Stats_ProvisionedInputs */



/**
* | output |
* | --- |
* | "Provisioned Users" |
*
* @param {Scim_Stats_ProvisionedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_stats_provisioned = /** @type {((inputs?: Scim_Stats_ProvisionedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Stats_ProvisionedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereitgestellte Benutzer")
	return /** @type {LocalizedString} */ ("Provisioned Users")
});